import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from '../locales/en/translation.json'; 
import trTranslation from '../locales/tr/translation.json'; 
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector) 
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('language') || 'tr',  
    fallbackLng: 'tr',  
    debug: true,
    interpolation: {
      escapeValue: false, 
    },
    resources: {
      en: { translation: enTranslation },
      tr: { translation: trTranslation },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], 
    },
  });

export default i18n;
